import {IconSeekers} from "ui-seeker/core";
import * as React from "react";
import {useAppCalendarAlertsActions} from "../@hooks";

export default function AppCalendarAlertsAction({ date }) {

    const {handleOpenAlertsDrawer, alerts} = useAppCalendarAlertsActions(date)

    if (!alerts || !alerts.length) return null

    return <div onClick={() => handleOpenAlertsDrawer(date)} style={{overflow: 'visible'}}
                className="toolkit bottom-right light calendar-icons">
        <span className="red-circle">{alerts.length > 99 ? '99+' : alerts.length}</span>
        <IconSeekers icon="bell" iconType="fontAwesome"/>
    </div>
}